export type TSplitType = 'Total' | 'Contractual' | 'Transactional'
export type TSType = '' | 'c' | 't'
export type TCTType = 'c' | 't'
export type TSettingsSuffix = 'quarter' | 'sob' | 'units' | 'sob-details' | 'yearly-planning'
export const SETTINGS_CONTRACTUAL_SUFFIX = 'contractual'
